export const SET_IS_LOADING = "LEADS/SET_IS_LOADING";
export const SET_LEAD_LIST = "LEADS/SET_LEAD_LIST";
export const SET_TOTAL_ITEMS = "LEADS/SET_TOTAL_ITEMS";
export const SET_SOURCE_LIST = "LEADS/SET_SOURCE_LIST";
export const SET_TOTAL_SOURCE_ITEMS = "LEADS/SET_TOTAL_SOURCE_ITEMS";
export const COMMENT_LIST_ADD_ITEM = "LEADS/COMMENT_LIST_ADD_ITEM";
export const SET_HISTORIC_LIST = "LEADS/SET_HISTORIC_LIST";
export const SET_SEARCH = "LEADS/SET_SEARCH";
export const LEAD_LIST_ADD_ITEM = "LEADS/LEAD_LIST_ADD_ITEM";
export const LEAD_LIST_UPDATE_ITEM = "LEADS/LEAD_LIST_UPDATE_ITEM";
export const LEAD_LIST_REMOVE_ITEM = "LEADS/LEAD_LIST_REMOVE_ITEM";
export const LEAD_LIST_UNARCHIVE_ITEM = "LEADS/LEAD_LIST_UNARCHIVE_ITEM";
